// @ts-nocheck
import ShareTab from './ShareTab';
import { Box, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { XGButton } from 'xg-cl';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const ShareModal = ({ open, onClose, tripId, type, isPublic, setIsPublic }) => {
  const { t } = useTranslation(['trip', 'common']);

  const title =
    type === 'proposal'
      ? t('trip:shareProposal', 'Share Proposal')
      : t('trip:shareFinalItinerary', 'Share Final Itinerary');

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent
        sx={{ padding: '25px 24px !important', paddingTop: '0 !important' }}
      >
        <ShareTab
          tripid={tripId}
          isPublic={isPublic}
          setIsPublic={setIsPublic}
          type={type}
        />
        <Box className='share-dialog-close-button'>
          <XGButton
            data-testid='share-dialog-close-button'
            id='dialog-close-button'
            text={t('common:close')}
            type='secondary'
            size='large'
            variant='outlined'
            onClick={onClose}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

ShareModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tripId: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['proposal', 'final']).isRequired,
  isPublic: PropTypes.bool.isRequired,
  setIsPublic: PropTypes.func.isRequired
};

export default ShareModal;
